import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { verifyOtp } from "@/redux/slices/auth"; // Import the verifyOtp function
import { checkEmailExists } from "@redux/slices/auth";
import { enqueueSnackbar } from "notistack";

type AuthFormProps = {
  handleOnSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  setData: React.Dispatch<
    React.SetStateAction<{ email: string; password: string }>
  >;
  data: { email: string; password: string };
  otpCode: string;
  setOtpCode: React.Dispatch<React.SetStateAction<string>>;
  error: string;
  isOtpSent: boolean; // New prop for OTP state
  handleGoogleSignIn: () => Promise<void>;
  IsPassword: boolean;
  navigate: (path: string) => void; // Update the type to accept a string argument
  setIsPassword: React.Dispatch<React.SetStateAction<boolean>>;
  handleSendOtp: () => Promise<void>;
};

const AuthLoginForm = ({
  handleOnSubmit,
  isLoading,
  data,
  setData,
  otpCode,
  setOtpCode,
  error,
  isOtpSent,
  navigate,
  IsPassword,
  setIsPassword,
  handleSendOtp,
}: AuthFormProps) => {
  const handleOtpSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent default form submission
    try {
      await verifyOtp(data.email, otpCode, navigate); // Call verifyOtp with email, otpCode, and navigate
    } catch (err) {
      console.error("OTP verification failed:", err);
    }
  };

  const handleForget = async () => {
    try {
      const emailExists = await checkEmailExists(data.email);

      if (emailExists) {
        console.log("Email exists, sending OTP...");
        await handleSendOtp();
      } else {
        console.log("Email does not exist in the system.");
        enqueueSnackbar("Email does not exist", { variant: "error" });
      }
    } catch (error) {
      console.error("Error during password recovery process:", error);
    }
  };

  return (
    <Card className="lg:w-[600px] w-[400px] p-5">
      <CardHeader>
        <CardTitle className="text-3xl font-semibold text-center">
          {/* {IsPassword ? ""}
          {isOtpSent ? "Enter Your OTP" : "Welcome Back"} */}
          {IsPassword
            ? "Account Recover"
            : isOtpSent
            ? "Enter Your OTP"
            : "Welcome Back"}
        </CardTitle>
        <div className="flex items-center justify-center text-center text-md text-slate-500">
          <p className="max-w-[370px]">
            {IsPassword
              ? "Enter the OTP sent to your email to verify your account."
              : isOtpSent
              ? "Enter the OTP sent to your email to verify your account."
              : "Please log in to access your dashboard."}
          </p>
        </div>
      </CardHeader>
      <CardContent className="pt-5">
        <form
          onSubmit={
            !IsPassword
              ? isOtpSent
                ? handleOtpSubmit
                : handleOnSubmit
              : undefined
          }
          className="grid gap-4"
        >
          {IsPassword ? (
            <>
              <div className="grid gap-2">
                <Label htmlFor="otpCode">OTP Code</Label>
                <Input
                  className="py-5"
                  id="otpCode"
                  type="text"
                  placeholder="Enter OTP"
                  required
                  value={otpCode}
                  onChange={(e) => setOtpCode(e.target.value)}
                />
              </div>
            </>
          ) : !isOtpSent ? (
            <>
              {/* Email and Password Fields */}
              <div className="grid gap-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  className="py-5"
                  id="email"
                  type="email"
                  placeholder="m@example.com"
                  required
                  value={data.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                />
              </div>
              <div className="grid gap-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  className="py-5"
                  id="password"
                  type="password"
                  value={data.password}
                  placeholder="Password"
                  onChange={(e) =>
                    setData({ ...data, password: e.target.value })
                  }
                />
              </div>
            </>
          ) : (
            <>
              {/* OTP Field */}
              <div className="grid gap-2">
                <Label htmlFor="otpCode">OTP Code</Label>
                <Input
                  className="py-5"
                  id="otpCode"
                  type="text"
                  placeholder="Enter OTP"
                  required
                  value={otpCode}
                  onChange={(e) => setOtpCode(e.target.value)}
                />
              </div>
            </>
          )}
          {error && (
            <div className="text-red-500 text-sm text-center">{error}</div>
          )}

          {IsPassword || isOtpSent ? (
            <></>
          ) : (
            <div
              className="text-sm cursor-pointer mb-5"
              onClick={() => {
                handleForget();
              }}
            >
              Forgot Password?
            </div>
          )}

          <Button isLoading={isLoading} type="submit" className="w-full py-5">
            {IsPassword ? "Verify OTP" : isOtpSent ? "Verify OTP" : "Log In"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default AuthLoginForm;
